import {useGetPatientCharacteristics} from '@/modules/patients/api/use-get-patient-characteristics'
import {useGetPatientProtocols} from '@/modules/patients/api/use-get-patient-protocols'
import {openPatientCharacteristicsDialog} from '@/modules/patients/components/dialogs/util'
import {AddEntryDialog} from '@/modules/patients/components/patient-details/therapy/dialogs/add-entry-dialog'
import {
  AddProtocolDialog,
  AddProtocolDialogProps,
} from '@/modules/patients/components/patient-details/therapy/dialogs/add-protocol'
import {dialog} from '@cypro/ui/components'
import {toaster} from '@cypro/ui/toaster'
import {useTranslate} from '@tolgee/react'
import {useCallback} from 'react'

export function useAddTherapyToPatient(props: AddProtocolDialogProps) {
  const {t} = useTranslate('common')
  const [characteristics] = useGetPatientCharacteristics(props.patientId)
  const [patientProtocols] = useGetPatientProtocols(props.patientId)

  const checkCharacteristics = useCallback(() => {
    if (characteristics) return Promise.resolve(true)

    toaster.warning({
      title: t('patient_missing_characteristics.title'),
      description: t('patient_missing_characteristics.description'),
      duration: 10000,
    })
    // if the result is false, it means the user aborted the operation
    // if it is true, it means the user completed the flow and we can display the protocol/entry dialog
    return openPatientCharacteristicsDialog(props.patientId)
  }, [t, characteristics, props])

  const addPatientProtocol = useCallback(async () => {
    const addCharacteristicsResult = await checkCharacteristics()
    if (!addCharacteristicsResult) return

    await dialog.open('add-patient-protocol', {
      children: <AddProtocolDialog {...props} />,
      contentProps: {minWidth: '50vw'},
    })
  }, [checkCharacteristics, props])

  const addPatientEntry = useCallback(async () => {
    const addCharacteristicsResult = await checkCharacteristics()
    if (!addCharacteristicsResult) return

    await dialog.open('add-therapy-entry', {
      children: <AddEntryDialog patientProtocols={patientProtocols} patientId={props.patientId} />,
    })
    dialog.close('add-therapy-entry', true)
  }, [checkCharacteristics, props, patientProtocols])

  return {addPatientProtocol, addPatientEntry}
}
